/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Socialmedia1Inputs */

const en_socialmedia1 = /** @type {(inputs: Socialmedia1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media`)
};

const de_socialmedia1 = /** @type {(inputs: Socialmedia1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soziale Medien`)
};

/**
* | output |
* | --- |
* | "Social Media" |
*
* @param {Socialmedia1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const socialmedia1 = /** @type {((inputs?: Socialmedia1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Socialmedia1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_socialmedia1(inputs)
	return de_socialmedia1(inputs)
});
export { socialmedia1 as "socialMedia" }